<template>
  <div>
    <el-dialog
      title="上传shader"
      :visible="shaderFlag"
      width="50%"
      :top="'6vh'"
      @close="shaderDialogClose"
    >
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="Code" name="code">
          <el-input
            type="textarea"
            :autosize="{ minRows: 20, maxRows: 20 }"
            placeholder="Codeing..."
            v-model="code"
          >
          </el-input>
          <div style="height: 10px"></div>
          <div class="uploadBtn">
            <el-button type="success" style="width: 100%" @click="uploadCode"
              >上传</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="File" name="file">
          <el-upload
            :http-request="uploadHttpFile"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
          <div style="height: 10px"></div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { uploadFile } from '../api/comment'
export default {
  name: 'uploadShader',
  data() {
    return {
      activeName: 'code',
      code: ''
    }
  },
  props: {
    name: String,
    shader: String,
    shaderFlag: Boolean
  },
  methods: {
    shaderDialogClose() {
      this.$emit('update:shaderFlag', false)
    },
    handleClick() {},
    uploadHttpFile(param) {
      if (this.name == '') {
        this.$message({
          type: 'info',
          message: '上传代码之前name必须填写'
        })
        return
      }
      let fileName = Date.now() + '.' + this.name
      var file = new File([param.file], fileName, { type: '' })
      var form = new FormData()
      form.append('file', file)
      uploadFile(form)
        .then((res) => {
          if (res.success) {
            this.$message.success("上传成功～")
            this.$emit('update:shader', res.data)
            this.$emit('update:shaderFlag', false)
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err
          })
        })
    },
    uploadCode() {
      if (this.name == '') {
        this.$message({
          type: 'info',
          message: '上传代码之前name必须填写'
        })
        return
      }
      if (this.code == '') {
        this.$message({
          type: 'info',
          message: 'code为空'
        })
        return
      }
      let fileName = Date.now() + '.' + this.name
      var file = new File([this.code], fileName, { type: '' })
      let form = new FormData()
      form.append('file', file)
      uploadFile(form)
        .then((res) => {
          if (res.success) {
            this.$message.success("上传成功～")
            this.$emit('update:shader', res.data)
            this.$emit('update:shaderFlag', false)
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err
          })
        })
    }
  }
}
</script>
<style scoped>
.uploadBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload-dragger {
  width: 100%;
}
</style>
